import { Alert } from 'antd5';
import styled from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const StyledAlert = styled(Alert)<{ $type?: string }>`
  ${({ theme, $type }) => {
    if (theme.themeName === Theme.Dark) {
      if (!$type || $type === 'info') {
        return `
        background-color: ${theme.tealBackgroundColor};
        border-color: ${theme.lightBlue};
      `;
      }
      if ($type === 'warning') {
        return `background-color: ${theme.tableBannerBackgroundColor};`;
      }
      if ($type === 'error') {
        return `background-color: ${theme.lightRed};`;
      }
      if ($type === 'success') {
        return `background-color: ${theme.green};`;
      }
    }
  }}
`;
